<script setup lang="ts">
  import { EAppCustomHooks } from '#shared/types/custom.hooks.types';

  const props = defineProps<{
    sidebar?: boolean;
  }>();

  const { isMobile } = useDeviceType();
  const balance = computed(() => stores.user.formattedBalance.replace(' ', ''));
  const pmBalance = computed(() => {
    if (!props.sidebar) return stores.user.formattedPmBalance;
    return stores.user.formattedPmBalance.replace(' PM', '');
  });

  const tooltipText = 'Your Play Money balance';
  const tooltipIsOpen = ref(false);

  const nuxtApp = useNuxtApp();
  const unsubscribeHook = nuxtApp.hook(EAppCustomHooks.PlayMoneyShowTooltip, () => {
    tooltipIsOpen.value = true;
  });

  onBeforeUnmount(unsubscribeHook);
</script>

<template>
  <div
    v-if="isMobile && !sidebar"
    class="flex items-center gap-2.5 text-white text-center font-barlow text-xs font-medium leading-[100%] max-xs:px-2 px-3 py-4 bg-black/30 rounded-6px"
    @click="() => stores.modals.showCashierModal()"
  >
    <UTooltip
      v-model:open="tooltipIsOpen"
      arrow
      :ui="{ content: 'text-white font-barlow text-sm font-medium px-3 py-5' }"
      :text="tooltipText"
      disable-closing-trigger
    >
      <span class="text-gold">{{ pmBalance }}</span>
    </UTooltip>
    <span>|</span>
    <span>{{ balance }}</span>
  </div>

  <div
    v-else
    class="flex items-center gap-2.5 self-stretch"
    :class="{ 'h-10': sidebar }"
    @click="() => stores.modals.showCashierModal()"
  >
    <div v-if="sidebar" class="h-full flex items-center gap-2.5 pr-6 pl-2.5 py-0 rounded-6px bg-black/30 basis-full">
      <SvgoIconPlayMoney class="size-[30px]" />
      <span class="text-gold font-barlow text-base font-medium leading-[100%]">{{ pmBalance }}</span>
    </div>
    <UTooltip
      v-else
      v-model:open="tooltipIsOpen"
      arrow
      :ui="{ content: 'text-white font-barlow text-lg font-medium px-5 py-8' }"
      :text="tooltipText"
      disable-closing-trigger
    >
      <div class="h-full flex items-center gap-2.5 pr-6 pl-2.5 py-0 rounded-6px bg-black/30">
        <SvgoIconPlayMoney class="size-[30px]" />
        <span class="text-gold font-barlow text-base font-medium leading-[100%]">{{ pmBalance }}</span>
      </div>
    </UTooltip>

    <div
      class="h-full flex items-center gap-2.5 pr-6 pl-2.5 py-0 rounded-6px bg-black/30 self-stretch"
      :class="{ 'basis-full': sidebar }"
    >
      <SvgoIconDollar class="size-[30px]" />
      <span class="text-white font-barlow text-base font-medium leading-[100%]">{{ balance }}</span>
    </div>
  </div>
</template>
